import contentPromoSuccess from 'public/static/images/content-promo-success.svg';
import { screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

export default function EmailSubmitCard({ email }: { email: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="card" data-testid="success-card">
      <img src={contentPromoSuccess} className="success-mark" alt="checkmark" />
      <div className="title">{t('contentModal.successTitle')}</div>
      <div className="text">{t('contentModal.successSubheader')}</div>
      <div className="email-text">{email}</div>
      <style jsx>
        {`
          .card {
            width: 100%;
            padding: 61px 24px 0px;
            text-align: center;
          }

          .title {
            margin-bottom: 12px;
            font-weight: 700;
            font-size: 28px;
            line-height: 34px;
            letter-spacing: 0.2px;
          }

          .text {
            margin-bottom: 4px;
            font-weight: 400;
            font-size: 16px;
            letter-spacing: 0.2px;
          }

          .email-text {
            line-height: 22px;
            font-weight: 600;
          }

          .success-mark {
            height: 52px;
            margin-bottom: 11px;
          }

          @media (min-width: ${screen.smMin}) {
            .card {
              width: 368px;
              padding: 64px 40px 0px;
              text-align: left;
            }

            .title {
              margin-bottom: 12px;
              font-weight: 700;
              font-size: 30px;
              line-height: 40px;
              letter-spacing: 0.2px;
            }

            .text {
              margin-bottom: 4px;
              font-weight: 400;
              font-size: 16px;
              letter-spacing: 0.2px;
              line-height: 24px;
            }

            .success-mark {
              height: 52px;
              margin-bottom: 16px;
            }

            .email-text {
              margin-bottom: 4px;
            }
          }
        `}
      </style>
    </div>
  );
}
